<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div
    class="pa-2"
    style="display: grid;
    grid-gap: 12px;
  grid-template-columns: repeat(auto-fill,minmax(360px,1fr));"
  >
    <v-card
      v-for="(item,index) in productList"
      :key="index"
      class="pa-4 d-flex"
      elevation="0"
      @click="$emit('selected',item.metadata.code)"
    >
      <div class="d-block overflow-hidden flex-grow-1">
        <div class="d-flex align-center">
          <div
            v-if="item.images[0]"
            class="mr-4"
          >
            <v-img
              :src="item.images[0]"
              :width="18"
            />
          </div>

          <div
            class="text-body-1 text-truncate"
          >
            {{ item.name }}
          </div>
          <v-spacer />
          <div>
            <v-chip
              v-if="ownedProducts.includes(item.metadata.code)"
              color="amber lighten-4 black--text"
              label
              small
            >
              {{ $t('AlreadyActivated') }}
            </v-chip>
            <v-chip
              v-else
              class="text-body-2"
              color="grey lighten-4"
              label
              small
            >
              <stripe-price-display
                :just-display="true"
                :price="item.prices"
              />
            </v-chip>
          </div>
        </div>
        <div
          class="my-2 text-body-2 text--secondary"
          style="min-height: 60px; display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;"
        >
          {{ item.description || $t('no_description') }}
        </div>
        <div>
          <v-icon>mdi-dots-horizontal</v-icon>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import StripePriceDisplay from '@/views/widget/commonLogic/StripePriceDisplay.vue'

export default {
  name: 'ProductsCard',
  components: { StripePriceDisplay },
  props: {
    productList: {},
    ownedProducts: {}
  },
  computed: {},
  watch: {
    productList (val) {
      console.log(val)
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
